import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import Sidebar from "../components/layout/Sidebar";
import Header from "../components/layout/Header";
import SsoSettings from "../features/members/SsoSettings";
import SignInSettings from "../features/members/SignInSettings";
import { useUser } from "../context/UserContext";
import { canManageOrgUsers } from "../utils/roles";
import "../features/account/account.scss";
import "../features/members/members.scss";

/**
 * Settings → Sign-in methods: how members of this admin dashboard sign in.
 * Single sign-on providers and the org's sign-in policy live together here;
 * Members stays about people.
 */
const LoginMethods = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [policyKey, setPolicyKey] = useState(0);
  const { user } = useUser();
  const tenantId = user?.org_id || "";

  if (!canManageOrgUsers()) return <Navigate to="/account" replace />;

  return (
    <div className="account-container">
      <Sidebar className={isSidebarOpen ? "open" : ""} />
      {isSidebarOpen && <div className="overlay" onClick={() => setIsSidebarOpen(false)} />}
      <div className="account-content">
        <Header onMenuClick={() => setIsSidebarOpen((p) => !p)} />
        <div className="members">
          <div className="members__head">
            <div>
              <h2>Sign-in methods</h2>
              <p>How members sign in to this admin dashboard. The mobile app is configured separately.</p>
            </div>
          </div>
          <SsoSettings tenantId={tenantId} onChanged={() => setPolicyKey((k) => k + 1)} />
          <SignInSettings tenantId={tenantId} refreshKey={policyKey} />
        </div>
      </div>
    </div>
  );
};

export default LoginMethods;
